var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var traverse = function (root, visit) {
    _traverse(root, null, visit);
};
export var unsafeTraverse = function (root, visit) {
    _traverse(root, null, visit, false);
};
export function isCstNode(object) {
    return Boolean(object && 'name' in object);
}
export function isIToken(object) {
    return Boolean(object && 'tokenType' in object);
}
// Given a chevrotain ruleStack (array of rule parser rule names) and a root
// CstNode, attempts to walk down the tree branching out from that node by
// following the rule stack to its end, and returns the first CstElement found
// at that point (or undefined if the ruleStack path cannot be completed).
// Useful to avoid lots of boilerplate.
export function getFirstChildCstElementByRuleStack(ruleStack, rootCstNode) {
    if (!ruleStack || !ruleStack.length) {
        // No stack to follow, so just return the root node provided.
        return rootCstNode;
    }
    var currentCstElement = rootCstNode;
    for (var _i = 0, ruleStack_1 = ruleStack; _i < ruleStack_1.length; _i++) {
        var ruleName = ruleStack_1[_i];
        if (!isCstNode(currentCstElement) ||
            !currentCstElement.children[ruleName]) {
            // The ruleStack was not exhausted and yet we can go no further; return
            // `undefined`, since there is no value at the specified path.
            return;
        }
        currentCstElement = currentCstElement.children[ruleName][0];
    }
    return currentCstElement;
}
var TraverseContext = /** @class */ (function () {
    function TraverseContext(_a) {
        var node = _a.node, parentCtx = _a.parentCtx;
        this.node = __assign({}, node);
        this.parentCtx = __assign({}, parentCtx);
    }
    return TraverseContext;
}());
var _traverse = function (root, ctx, visit, visitSafely) {
    if (ctx === void 0) { ctx = new TraverseContext({ node: root }); }
    if (visitSafely === void 0) { visitSafely = true; }
    if (!isCstNode(root)) {
        // must be a token
        return visit(visitSafely ? __assign({}, ctx) : ctx);
    }
    // is a grammar rule node
    var children = root.children;
    Object.keys(children).forEach(function (key) {
        var childType = children[key];
        if (!childType.length) {
            return;
        }
        childType.forEach(function (child) {
            var childCtx = visitSafely
                ? new TraverseContext({ node: child, parentCtx: ctx })
                : { node: child, parentCtx: ctx };
            var afterVisit = function (transformedCtx) {
                var nextCtx = childCtx;
                if (transformedCtx) {
                    nextCtx = visitSafely
                        ? new TraverseContext({
                            node: transformedCtx.node,
                            parentCtx: transformedCtx.parentCtx,
                        })
                        : {
                            node: transformedCtx.node,
                            parentCtx: transformedCtx.parentCtx,
                        };
                }
                _traverse(child, nextCtx, visit, visitSafely);
            };
            visit(childCtx, afterVisit);
        });
    });
};
